import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from '../../shared/guards/auth.guard';
import { BallotsComponent } from './ballots.component';
import { IecDetailsComponent } from './iec/iec-details/iec-details.component';
import { ballotCreationPageGuard, ballotsPageGuard } from '../../shared/guards/role.guard';
import { SdDetailsComponent } from './sd/sd-details/sd-details.component';
import { SrsDetailsComponent } from './srs/srs-details/srs-details.component';
import { CiDetailsComponent } from './cib/cib-details/ci-details.component';
import { SrsCreateComponent } from './srs/srs-create/srs-create.component';
import { BallotDashboardComponent } from './ballot-dashboard/ballot-dashboard.component';
import { CibCreateComponent } from './cib/cib-create/cib-create.component';
import { IecCreateComponent } from './iec/iec-create/iec-create.component';


const routes: Routes = [
  {
    path: 'ballots',
    component: BallotsComponent,
    canActivate: [authGuard, ballotsPageGuard],
  },
  {
    path: 'ballots/create',
    component: BallotDashboardComponent,
    canActivate: [authGuard, ballotCreationPageGuard],
  },
  {
    path: 'ballots/cib/create-ballot',
    component: CibCreateComponent,
    canActivate: [authGuard, ballotCreationPageGuard],
  },
  {
    path: 'ballots/iec/create-ballot',
    component: IecCreateComponent,
    canActivate: [authGuard, ballotCreationPageGuard],
  },
  {
    path: 'ballots/srs/create-ballot',
    component: SrsCreateComponent,
    canActivate: [authGuard, ballotCreationPageGuard],
  },
  {
    path: 'ballots/cib/:id',
    component: CiDetailsComponent,
    canActivate: [authGuard, ballotsPageGuard],
    // canActivate can be used here as well, sd ballot specific guards can be added here.
    //   ex: all sd related features can only be used by internal users
  },
  {
    path: 'ballots/iec/:id',
    component: IecDetailsComponent,
    canActivate: [authGuard, ballotsPageGuard],
    // canActivate can be used here as well, sd ballot specific guards can be added here.
    //   ex: all sd related features can only be used by internal users
  },
  {
    path: 'ballots/npb/:id',
    component: SdDetailsComponent,
    canActivate: [authGuard, ballotsPageGuard],
    // canActivate can be used here as well, sd ballot specific guards can be added here.
    //   ex: all sd related features can only be used by internal users
  },
  {
    path: 'ballots/srs/:id',
    component: SrsDetailsComponent,
    canActivate: [authGuard, ballotsPageGuard],
    // canActivate can be used here as well, sd ballot specific guards can be added here.
    //   ex: all sd related features can only be used by internal users
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BallotRoutingModule { }
